import { Col, Row } from 'antd'
import SubDetalleCard from './SubDetalleCard'

const SubDetalles = ({ data }) => {
  return (
    <Row gutter={[0, 12]}>
      {data.map(item =>
        <Col xs={24} key={item.id}>
          <SubDetalleCard {...item} />
        </Col>
      )}
    </Row>
  )
}

export default SubDetalles